export class OrderItemUpdateRequest {
    /**Id de item de pedido */
    public id: number;
    /**Cantidad de productos de item de pedido */
    public count: number;
    /**Código de cliente */
    public clientCode: string;
    /**Cantidad de pagos mensuales */
    public monthlyPaymentCount: number;
    public documentType:string;
    public documentNumber:string;
    public isFnb:boolean;
}